import React, { useState } from 'react'
import { styled } from 'linaria/react'
import { theme } from '../../../Theme'
import { Breadcrumbs } from '../../BreadCrumbs/BreadCrumbs'
import { stringByPropertyNameHasValidValue } from '../../Util/Helpers'
import Collapsible from '../Collapsible'

const HeroContainer = styled.div`
   position: relative;
   background-color: ${theme.colors.white};
   .page-hero-title {
      font-size: 2.8rem;
      font-weight: 700;
   }

   .page-hero-second {
      position: relative;
      border-radius: 2rem 0 0 0;
      overflow: hidden;
      height: ${props => (props.imageUrl ? '270px' : 'auto')};
   }

   .page-hero-description {
      max-width: 600px;
      ${theme.above.xxl} {
         max-width: 800px;
      }
   }

   .page-hero-second .img-background {
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center;
      max-height: unset;
   }
`

const DesktopOverlay = styled.div`
   position: absolute;
   width: 100%;
   height: 100%;
   z-index: 2;
   background: radial-gradient(
         350px 300px at 150px 80%,
         ${props => props.logoBgFade},
         transparent 100%
      ),
      radial-gradient(
         farthest-side at bottom left,
         ${props => props.logoBgFade},
         transparent 100%
      );
`

const BrandLogo = styled.img`
   height: auto;
   max-width: 135px;
`
const setBgLogoFade = bgLogoFadeProp => {
   switch (bgLogoFadeProp) {
      case 'light':
         return 'rgb(255, 255, 255, 0.8)'
      case 'dark':
         return 'rgb(0, 0, 0, 0.8)'
      case 'transparent':
         return 'rgb(255, 255, 255, 0.0)'
      default:
         return 'rgb(255, 255, 255, 0.0)'
   }
}

const BrandLogoContent = ({ brandLogo, brandBgLogoFade, activeCategory }) => {
   const logoBgFade = setBgLogoFade(brandBgLogoFade)
   return (
      <>
         <DesktopOverlay logoBgFade={logoBgFade} />
         <div className="d-flex flex-column position-absolute top-0 w-100 h-100 z-3 align-items-start justify-content-end px-64 py-32">
            <BrandLogo
               alt={
                  activeCategory?.name
                     ? `${activeCategory?.name}-logo`
                     : 'Brand-logo'
               }
               src={brandLogo}
            />
         </div>
      </>
   )
}

const DesktopBanner = ({
   bannerContent,
   activeCategory,
   parents,
   showDescriptionContent,
   imageUrl,
   brandLogo,
   brandBgLogoFade,
   isSingleBrand,
   name
}) => {
   const showBrandLogoContent = stringByPropertyNameHasValidValue(brandLogo) && isSingleBrand
   
   return (
      <HeroContainer imageUrl={imageUrl} className="page-hero">
         <div className="row p-0 m-0">
            <div className="page-hero-first col-12 col-xl-6 pt-32 pb-32 pr-32 pl-128 d-flex flex-column">
               <div className="page-hero-first-top d-flex flex-column">
                  <Breadcrumbs
                     hideLast
                     parents={parents}
                     title={
                        activeCategory?.breadcrumbText || activeCategory?.name
                     }
                     className="mb-3"
                  />
                  <h1 className="page-hero-title">{name}</h1>
               </div>
               <div className="page-hero-first-bottom d-flex flex-column">
                  {showDescriptionContent && (
                     <article className="page-hero-description pt-8 pb-0 m-0">
                        <Collapsible
                           content={bannerContent}
                           open={false}
                           closedVisibleHeight={80}
                           useDarkText={true}
                        ></Collapsible>
                     </article>
                  )}
               </div>
            </div>
            <div className="page-hero-second col-12 col-xl-6 p-0">
               {imageUrl && (
                  <img
                     className="img-background img-fluid"
                     src={imageUrl}
                     alt={activeCategory?.name}
                  />
               )}
               {showBrandLogoContent && (
                  <BrandLogoContent
                     brandLogo={brandLogo}
                     brandBgLogoFade={brandBgLogoFade}
                     activeCategory={activeCategory}
                  />
               )}
            </div>
         </div>
      </HeroContainer>
   )
}

export default DesktopBanner

